<template>
    <div>
        <div v-if="loading" class="loading_page">
            <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <b-card no-body>

            <b-card-header class="pb-50">

            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col md="12" sm="12" lg="12" class="mb-md-0 mb-2">
                        <label>{{ $t('Category') }}</label>
                        <v-select multiple :close-on-select="false" label="name"
                            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="categoriesFilter"
                            :options="categoriesOptions.map((i) => ({ id: i, name: $t(i) }))" class="w-100"
                            :reduce="val => val.id" @input="(val) => $emit('update:categoriesFilter', val)" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" md="12" class="mb-md-0 mb-2">
                        <label>{{ $t('Owners') }}</label>
                        <v-select multiple :close-on-select="false"
                            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="ownersFilter"
                            label="name" :options="ownersOptions.map((o) => ({ id: o.id, name: o.name }))" class="w-100"
                            :reduce="val => val.id" @input="(val) => $emit('update:ownersFilter', val)" />
                    </b-col>
                </b-row>
                <b-row>


                    <b-col lg="12" md="12" class="mb-md-0 mb-2">
                        <label>{{ $t('Contracts') }}</label>
                        <v-select multiple :close-on-select="false"
                            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :value="contractsFilter"
                            :getOptionLabel="c => c.name" :options="contractsOptions" class="w-100"
                            :reduce="val => val.id" @input="(val) => $emit('update:contractsFilter', val)" />
                    </b-col>


                </b-row>

                <b-row class="mt-5">
                    <b-col cols="6" md="6" mb="4">
                        <b-input-group size="md">
                            <b-form-input id="filterInput" v-model="filter" type="search"
                                :placeholder="$t('Type to Search')" />
                        </b-input-group>

                    </b-col>
                    <b-col cols="6" md="6" mb="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                           
                            class="per-page-selector d-inline-block mx-50 mr-0" />
                        <label>{{ $t('entries') }}</label>
                    </b-col>

           
                    <b-table striped class="mb-0 mt-2" :items="geofencesList" :fields="['name', 'list']"
                        :filter="filter"  @filtered="onFiltered" :per-page="perPage" :current-page="currentPage">
                        <template #head(list)="data">
                            <b-form-checkbox :checked="checkAllRef" :value="true" @change="checkAll(data, $event)" />
                        </template>


                        <template #cell()="data">
                           
                            <b-form-checkbox :value="true" v-model="data.item.checked"
                                @change="$emit('disSelectGeofenceById', data.item.id, $event)" />
                        </template>
                        <template #cell(name)="data">
                            {{ data.item.name }}
                        </template>
                    </b-table>

                    <b-row>
                        <b-col cols="6" sm="6" class="d-flex align-items-center  ">

                            <b-pagination v-model="currentPage" :total-rows="totalRows > 1?totalRows:geofencesList.length"
                                :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0"
                                prev-class="prev-item" next-class="next-item">
                                <template #prev-text>
                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                </template>
                                <template #next-text>
                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                </template>
                            </b-pagination>

                        </b-col>
                    </b-row>
                </b-row>
            </b-card-body>

        </b-card>
    </div>
</template>

<script>
import {
    BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BTable, BFormCheckbox, BPagination, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'
import { OrbitSpinner } from 'epic-spinners'
import { CpuIcon } from 'vue-feather-icons'
export default {
    name: 'GeofenceFilter',
    components: {
        BRow, BButton,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        vSelect,
        BTable, BFormCheckbox, BPagination, OrbitSpinner, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend
    },
    props: {

        categoriesFilter: {
            type: Array,
            default: [],
        },

        contractsFilter: {
            type: Array,
            default: [],
        },
        ownersFilter: {
            type: [Array],
            default: [],
        },


        categoriesOptions: {
            type: Array,
            required: true,
        },


        ownersOptions: {
            type: Array,
            required: true,
        },
        contractsOptions: {
            type: Array,
            required: true,
        },
        geofencesList: {
            type: Array,
            required: true

        },
        loading: {
            type: Boolean,
            required: true
        }

    },
    setup(props, { root, emit }) {
        const filter = ref(null);
        const totalTable = ref(27)
        const currentPage = ref(1)
        const perPageOptions = [5, 10, 25, 50, 100, 500, 1000, 2000]
        const perPage = ref(10)
        const totalRows=ref(0)
        const checkAllRef = ref(true)
        totalRows.value=props.geofencesList.length + 1
        const checkAll = (data, event) => {

            checkAllRef.value = event;

            emit('disSelectGeofenceById', event ? 0 : -1)

        }
        //totalTable.value=props.geofencesList.length
   const     onFiltered=(filteredItems)=> {    

         totalRows.value = filteredItems.length
          currentPage.value = 1
    }
        return {
            totalRows,
            checkAll,
            checkAllRef,
            totalTable,
            currentPage,
            perPageOptions,
            perPage,
            filter,
            onFiltered

        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
